<div rxVirtualViewObserver [root]="null" [rootMargin]="'100px 100px'" [threshold]="0.1">
    @for (bet of bybBetslipEventsSignal()?.prcrCombos; track $index) {
        <div data-crlat="preCreatedBetBuilderBettingContainer" class="betting-container" rxVirtualView>
            <div *rxVirtualViewContent>
                @for (event of bet?.events; track $index) {
                    <pre-bet-builder-list-item [eventRef]="bybBetslipEventsSignal()?.eventsRef?.[0]" [bet]="bet"> </pre-bet-builder-list-item>
                }
            </div>
        </div>
    }
</div>
